export default __webpack_public_path__ + "static/creotech-00ce93e546b5197ca84ff66e4f632405.png";